<template>
  <svg
    :class="['icon', size]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30.4 20.06"
  >
    <path
      class="cls-1"
      d="M29.95.49c-.62-.64-1.63-.65-2.26-.04l-16.36,15.85L2.64,8.84c-.67-.57-1.68-.5-2.26.17-.58.67-.5,1.68.17,2.26l9.79,8.41s.03.01.04.02c.13.11.28.2.43.25.02,0,.04.01.06.02.16.05.33.09.5.09,0,0,0,0,0,0h0s0,0,0,0c.18,0,.37-.04.54-.1.02,0,.05-.01.07-.02.17-.07.32-.17.46-.29.01-.01.03-.02.05-.03L29.91,2.75c.63-.62.65-1.63.04-2.26Z"
    />
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    size: {
      type: String,
      default: 'size'
    }
  }
})
</script>

<style lang="scss" scoped>
.icon {
  fill: currentColor;
  stroke-width: 0;
}
.size {
  width: 1em;
  height: 1em;
}
.lg {
  width: 1.25em;
  height: 1.25em;
}
.sm {
  width: 0.85em;
  height: 0.85em;
}
</style>
